package co.maytes.standupbot.dashboard.features.standupruns

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.Badge
import co.maytes.standupbot.dashboard.components.widgets.BadgeTone
import co.maytes.standupbot.shared.dto.standuprun.StandupRunStatusDto
import com.varabyte.kobweb.compose.ui.Modifier

@Composable
fun StandupStatusChip(status: StandupRunStatusDto, modifier: Modifier = Modifier) {
    val (label, tone) = when (status) {
        StandupRunStatusDto.POSTED -> "Posted" to BadgeTone.Success
        StandupRunStatusDto.PENDING -> "Pending" to BadgeTone.Neutral
        StandupRunStatusDto.GENERATING -> "Generating" to BadgeTone.Accent
        StandupRunStatusDto.DRAFTED -> "Draft" to BadgeTone.Accent
        StandupRunStatusDto.FAILED -> "Failed" to BadgeTone.Error
        StandupRunStatusDto.NO_ACTIVITY -> "No activity" to BadgeTone.Warning
        StandupRunStatusDto.SKIPPED -> "Skipped" to BadgeTone.Neutral
    }
    Badge(label = label, tone = tone, modifier = modifier)
}
